var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cms-block',_vm._b({attrs:{"inline":"","no-padding":false},on:{"block-selected":_vm.selectBlock}},'cms-block',_vm.$props,false),[_c('cms-component-glyph',_vm._b({attrs:{"comp-id":"glyph","component":_vm.block.glyph}},'cms-component-glyph',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }